<div class="post-it">
    <div class="chip-list" aria-label="post-it selection">
        <nz-tag *ngFor="let item of chipList"
        nzColor="processing"
        draggable="true"
        [attr.data-drag-data]="item"
        (dragstart)="dragstart_handler($event)">{{item}}</nz-tag>
    </div>
</div>
